// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { Session } from "../../../data/app-core/session";
import { Node } from "../../../data/app-core/node";
import { NodeRoute } from "../../../data/app-core/node-route";
import { SitePreferencesSet } from "../../../data/app-core/site-preferences-set";
import { SearchPreference } from "../../../data/app-core/search-preference";
import { Role } from "../../../data/identity/role";
import { EnvelopeDocument } from "../base/envelope-document";

export class SessionDocument extends EnvelopeDocument {
	public override Item: Session = new Session();
	public Nodes: Node[] = [];
	public NodeRoutes: NodeRoute[] = [];
	public SitePreferencesSet: SitePreferencesSet = new SitePreferencesSet();
	public SearchPreferences: SearchPreference[] = [];
	public Roles: Role[] = [];
}